var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.369 10.228C20.3698 9.54662 20.3118 8.86638 20.1956 8.19481H10.6998V12.046H16.1386C16.0273 12.6611 15.7917 13.2474 15.4461 13.7697C15.1005 14.2919 14.6519 14.7393 14.1275 15.0847V17.5846H17.3734C19.274 15.8444 20.369 13.2709 20.369 10.228Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6998 20C13.4171 20 15.705 19.1139 17.3734 17.5862L14.1275 15.0864C13.2241 15.6947 12.0605 16.0419 10.6998 16.0419C8.0734 16.0419 5.8442 14.2836 5.04705 11.9143H1.70325V14.4906C2.54132 16.1467 3.82641 17.5389 5.41506 18.5118C7.0037 19.4847 8.83336 19.9999 10.6998 20V20Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04701 11.914C4.62559 10.6724 4.62559 9.32792 5.04701 8.08638V5.51012H1.7032C0.998184 6.90332 0.631012 8.44094 0.631012 10.0002C0.631012 11.5594 0.998184 13.097 1.7032 14.4902L5.04701 11.914Z",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6998 3.95879C12.1357 3.93549 13.5233 4.47429 14.5624 5.45872L17.4363 2.60469C15.614 0.904883 13.1998 -0.0283412 10.6998 0.000656061C8.83336 0.000740536 7.0037 0.515984 5.41506 1.48886C3.82641 2.46174 2.54132 3.85397 1.70325 5.5101L5.04705 8.08636C5.8442 5.71704 8.0734 3.95879 10.6998 3.95879Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/googleIcon.16580087efcc2880adeaadf500a72249.svg";
export { ForwardRef as ReactComponent };